const cargoDescricoes = {
  1: 'Profissional da Escola de Saúde Pública (ESP) ou da Gerência de Ensino e Pesquisa (GEP/HU) que realizará o controle dos estágios de todos os estabelecimentos de saúde.',
  2: 'Profissional responsável por cadastrar a instituição de ensino, os campis e cursos.',
  3: 'Professor/profissional responsável por realizar as solicitações de estágio.',
  4: 'Profissional do estabelecimento de saúde que irá gerenciar o programa no sentido de disponibilização e validação das vagas, solicitação de contrapartida e controle das contrapartidas.',
};

export default cargoDescricoes;
